import React from "react";
import { MarkdownPage } from "./MarkdownPage";

export const DunjaNotes = () => (
  <MarkdownPage file="DunjaNotes.md" showMermaid />
);
